export const loadScript = ({ src, id, type, async, defer, crossorigin, dataset }) => {
  return new Promise((resolve, reject) => {
    if (document.querySelector(`script#${id}`)) {
      resolve(`Script "${src}" already loaded.`);
    }

    const script = document.createElement('script');
    script.id = id;
    script.src = src;
    script.type = type || 'text/javascript';
    async && (script.async = true);
    defer && (script.defer = true);
    crossorigin && (script.crossorigin = crossorigin);

    if (dataset) {
      Object.assign(script.dataset, dataset);
    }

    script.onload = () => resolve(`Script "${src}" loaded.`);
    script.onerror = () => reject(`Script "${src}" not loaded!`);

    document.head.appendChild(script);
  });
};
